import styled from "styled-components";
import { Link } from "react-router-dom";
import { Table } from "semantic-ui-react";

export const Celcius = styled.p` 
font-size: 26px;
font-family: sans-serif;
font-weight: 600;
`;
export const Desc = styled.p` 
font-size: 18px;
font-family: sans-serif;
font-weight: 400;
text-transform: uppercase;
`;

export const Div = styled.div` 
width:50%;
  margin:1rem;
`;

export const Temp = styled.div`
background-color:white;
width:100%;
height:70%;

`;

export const City = styled.div`
background-color:black;
color:white;
width:100%;
height:30%;
`;

export const Body = styled.div` 
background-color: #A64253;
  font-family: Poiret One;
`;

export const Date = styled.div`
flex: 0 0 30%;
height: 40%;
background: #70C1B3;
border-bottom-right-radius: $border-radius;
display: flex;
justify-content: space-around;
align-items: center;
color: white;
font-size: 30px;
font-weight: 800;
`;

export const Widget = styled.div`
margin: 0 auto;
align: center;
display: flex;
height: 350px;
width: 600px;
flex-wrap: wrap;
cursor: pointer;
border-radius: $border-radius;
box-shadow: 0 27px 55px 0 rgba(0, 0, 0, 0.3), 0 17px 17px 0 rgba(0, 0, 0, 0.15);

.weatherIcon{
  flex: 1 100%;
  height: 50%;
  border-top-left-radius: $border-radius;
  border-top-right-radius: $border-radius;
  background: #FAFAFA;
  font-family: weathericons;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 100px;
  
  i{
    padding-top: 30px;
  }
}

.weatherInfo{
  flex: 0 0 70%;
  height: 40%;
  background: #080705;
  border-bottom-left-radius: $border-radius;
  display: flex;
  align-items: center;
  color: white;
  
  .temperature{
    flex: 0 0 40%;
    width: 100%;
    font-size: 65px;
    display: flex;
    justify-content: space-around;
  }
  
  .description{
    flex: 0 60%;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    
    .weatherCondition{
      text-transform: uppercase;
      font-size: 35px;
      font-weight: 100;
    }
    
    .place{
      font-size: 15px;
    }
  }
}

.date{
  flex: 0 0 30%;
  height: 40%;
  background: #70C1B3;
  border-bottom-right-radius: $border-radius;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: white;
  font-size: 30px;
  font-weight: 800;
}
`;
